import addDays from "date-fns/addDays";
import moment from "moment";

export interface iStatementRecordFilter {
    From: string;
    To: string;
    CustomerID: number;
    StatementNo: string;
}

export class StatementRecordFilter {
    From: string;
    To: string;
    CustomerID: number;
    StatementNo: string;

    constructor();
    constructor(obj: iStatementRecordFilter);	
    constructor(obj?: iStatementRecordFilter) { 
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.CustomerID = obj?.CustomerID ?? 0;
        this.StatementNo = obj?.StatementNo ?? "";
    }
}

export interface iGenerateStatementRecordFilter {
    FromDate: string;
    ToDate: string;
}

export class GenerateStatementRecordFilter {
    FromDate: string;
    ToDate: string;

    constructor();
    constructor(obj: iGenerateStatementRecordFilter);	
    constructor(obj?: iGenerateStatementRecordFilter) { 
        this.FromDate = moment(obj?.FromDate ?? addDays(new Date(), -7)).format();
        this.ToDate = moment(obj?.ToDate ?? new Date()).format();
    }
}